import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.chro_user_assigned_uid !== model.chro_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.chro_user_modified_uid,
						assignedTo: modifiedModel.chro_user_assigned_uid,
						title: 'Nuovo Evento assegnato',
						body: `${model.user_modified_title} ti ha assegnato a "${model.chro_title}".`,
						url: `${window.location.origin}/chronology/details/${model.chro_uid}`,
						icon: 'history',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
